import { useMemo } from 'react';

import { Editor, loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';

import { getLanguage } from '@atlassian/bitkit-code';

import { MonacoEditorProps } from './types';

// This tells @monaco-editor/react to use the local monaco-editor package instead of trying
// to download it from a CDN.
loader.config({ monaco });

export const SourceFileMonacoEditor = ({
  readOnly,
  initialSource,
  height,
  fileName,
  theme,
}: MonacoEditorProps): JSX.Element => {
  const editorOptions = useMemo(
    () => ({
      readOnly,
    }),
    [readOnly]
  );

  const language = getLanguage(fileName)?.monaco;

  return (
    <Editor
      options={editorOptions}
      defaultValue={initialSource}
      defaultLanguage={language}
      height={height}
      theme={theme === 'dark' ? 'vs-dark' : 'light'}
    />
  );
};
